function isHexColorToRgbaOptions(alphaOrOptions) {
    return (typeof alphaOrOptions !== 'undefined' && typeof alphaOrOptions !== 'number');
}
function isValidAlpha(alpha) {
    return typeof alpha !== 'undefined' && alpha >= 0 && alpha <= 1;
}
/**
 * Converts a 3 or 6 digit hex color to an object with RGB values.
 * This is done without regular expressions to avoid security / DOS issues.
 *
 * @param color 3 or 6 digit hex code starting with #
 * @returns an object with separate R, G, and B values, returns undefined if there's something wrong with the given hex color
 */
export function getRGBfromHexColor(color) {
    if (!color.startsWith('#')) {
        return undefined;
    }
    const parts = color
        .split('')
        .slice(1)
        .map((digit) => parseInt(digit, 16));
    if (parts.some((digit) => isNaN(digit))) {
        return undefined;
    }
    if (parts.length === 3) {
        const [r, g, b] = parts;
        return { r: r * 17, g: g * 17, b: b * 17 };
    }
    if (parts.length === 6) {
        const [r1, r2, g1, g2, b1, b2] = parts;
        return { r: r1 * 16 + r2, g: g1 * 16 + g2, b: b1 * 16 + b2 };
    }
    return undefined;
}
/**
 * Converts a hex color to a full rgba() string
 *
 * @param color 3 or 6 digit hex code allowed
 * @param alphaOrOptions either the alpha value or an object with alpha and fallback values
 */
export function hexColorToRgba(color, alphaOrOptions) {
    let alpha = isHexColorToRgbaOptions(alphaOrOptions)
        ? alphaOrOptions.alpha
        : alphaOrOptions;
    if (!isValidAlpha(alpha)) {
        alpha = 1;
    }
    const rgb = getRGBfromHexColor(color);
    if (rgb) {
        return `rgba(${rgb.r},${rgb.g},${rgb.b},${alpha})`;
    }
    // fallback with rgbaFallback
    if (isHexColorToRgbaOptions(alphaOrOptions) && alphaOrOptions.rgbaFallback) {
        return alphaOrOptions.rgbaFallback;
    }
    const alphaFallback = isHexColorToRgbaOptions(alphaOrOptions) &&
        isValidAlpha(alphaOrOptions.alpha)
        ? alphaOrOptions.alpha
        : 0;
    // fallback with rgbFallback
    if (isHexColorToRgbaOptions(alphaOrOptions) && alphaOrOptions.rgbFallback) {
        return `rgba(${alphaOrOptions.rgbFallback.r},${alphaOrOptions.rgbFallback.g},${alphaOrOptions.rgbFallback.b},${alphaFallback})`;
    }
    // fallback with #000
    return `rgba(0,0,0,${alphaFallback})`;
}
